import { License, LicenseConfig, makeLicenseCapacities } from './license';
import { makeRatePlanCapacities, RatePlan, RatePlanConfig } from './ratePlan';
import { makeSubscriptionCapacities, Subscription, SubscriptionConfig } from './subscription';

export type CapacitiesConfig = LicenseConfig & RatePlanConfig & SubscriptionConfig;

export const makeCapacities = (config: CapacitiesConfig) => {
  return {
    ratePlan: (ratePlan: RatePlan) => {
      const capacities = makeRatePlanCapacities(ratePlan, config);
      const amendments = (subscription: Subscription) => {
        const subscriptionCapacities = makeSubscriptionCapacities(subscription, config);
        return capacities.amendments(subscriptionCapacities);
      };
      return { ...capacities, amendments };
    },
    subscription: (subscription: Subscription) => makeSubscriptionCapacities(subscription, config),
    license: (license: License) => makeLicenseCapacities(license, config),
  };
};
